<template>
  <div class="p-8 w-full max-w-3xl mx-auto bg-white rounded-lg shadow my-6">
    <h2 class="font-semibold uppercase text-gray-600">
      Driver Details
    </h2>

    <div class="flex justify-center">
      <img
        :src="driver.profileImage"
        :alt="driver.firstName"
        class="w-64 h-64 rounded-full"
      />
    </div>

    <div class="mt-6 space-y-4">
      <div class="flex space-x-4">
        <div class="w-full">
          <p class="text-gray-600">Name</p>
          <p class="text-gray-900 text-2xl">
            {{ driver.firstName }} {{ driver.lastName }}
          </p>
        </div>
        <div class="w-full">
          <p class="text-gray-600">Email</p>
          <p class="text-gray-900 text-2xl">
            {{ driver.email }}
          </p>
        </div>
      </div>
      <div class="flex space-x-4">
        <div class="w-full">
          <p class="text-gray-600">Contact Number</p>
          <p class="text-gray-900 text-2xl">
            {{ driver.phoneNumber }}
          </p>
        </div>
        <div class="w-full">
          <p class="text-gray-600">City</p>
          <p class="text-gray-900 text-2xl">
            {{ driver.city }}
          </p>
        </div>
      </div>
      <div class="flex space-x-4">
        <div class="w-full">
          <p class="text-gray-600">Business License</p>
          <div class="w-full relative" style="padding-top: 100%;">
            <img
              :src="driver.businessLicense"
              alt="Driver Business License"
              class="absolute inset-0 w-full h-full rounded-lg"
            />
          </div>
        </div>
        <div class="w-full">
          <p class="text-gray-600">Driver's License</p>
          <div class="w-full relative" style="padding-top: 100%;">
            <img
              :src="driver.drivingLicense"
              alt="Driver's License"
              class="absolute inset-0 w-full h-full rounded-lg"
            />
          </div>
        </div>
      </div>
      <div class="flex space-x-4">
        <div class="w-full">
          <p class="text-gray-600">Representation Paper</p>
          <div class="w-full relative" style="padding-top: 100%;">
            <img
              :src="driver.representationPaper"
              alt="Driver Representation Paper"
              class="absolute inset-0 w-full h-full rounded-lg"
            />
          </div>
        </div>
        <div class="w-full"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      driver: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        profileImage: "",
        city: "",
        vehicleType: "",
        businessLicense: "",
        drivingLicense: "",
        representationPaper: "",
      },
    };
  },
  created() {
    this.getDriver();
  },
  methods: {
    getDriver() {
      console.log("/drivers/" + this.$route.params.id);
      this.$http
        .get("/drivers/" + this.$route.params.id)
        .then(response => {
          console.log(response.data.driver);
          this.driver = response.data.driver;
        })
        .catch(err => console.log(err));
    },
  },
};
</script>
